import { APIURL } from '../constant/apiConstant'
import ApiService from './apiRequest'
import AsyncStorageFunc from '../utilities/asyncStorage';

  export const getStateList = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_STATE_LIST_SERVICE, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const getCityList = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_CITY_LIST_SERVICE, params)
        .then(res => {
          resolve(res);
        }).catch(err => {  reject(err); });
    });
  }
  export const updateMobile = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.UPDATE_MOBILENUMBER, params)
        .then((res) => {
          resolve(res);
        }).catch((err) => {  reject(err); });
    });
  };
  export const updateRcVerify = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.VERIFY_RC_UPDATE, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  }
  export const rcUpdateServiceRequest = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.RC_UPDATE_SERVICE_REQUEST, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  }
  export const rcUpdate = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.RC_UPDATE, params)
        .then(res => {
          resolve(res);
        }).catch(err => {  reject(err); });
    });
  }
  export const getAllVehiclesListForClosureTag = async () => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.CLOSURE_TAG_VEHICLES)
        .then(res => {
          resolve(res?.data || []);
        }).catch(err => { reject(err); });
    });
  };
  export const getServiceReq = params => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_SERVICE_REQ, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  };
  export const closureTag = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.CLOSURE_TAG, params)
        .then(res => {
          resolve(res);
        }).catch(err => {  reject(err);});
    });
  }
  export const closureTagRefundCheck = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.CLOSURE_TAG_REFUND_CHECK, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    });
  }
  export const getVehicleClass = async params => {
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    return new Promise((resolve, reject) => {
      let header = { deviceId: deviceId };
      ApiService.get(APIURL.GET_VEHICLE_CLASS, params, header)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    });
  };
  export const getDetailByRequestId = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.GET_DETAILS_BY_REQID_ENC, params, "userId")
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    });
  };
  export const UploadDoc = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.VERIFY_ENC, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    });
  };
  export const postHitBanner = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.POST_HIT_BANNER, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const updateEmail = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.UPDATE_EMAIL, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const getConfigurations = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_CONFIGURATIONS, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const getVehicleDetails = async params => {
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    let token = await AsyncStorageFunc.getData('TOKEN');
    const header = {deviceModel: "", appVersion: "", platform: "", network: "", Authorization: token ? "bearer " + token : "", vrn: params, deviceId: deviceId};
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.DASHBOARD_VEHICLE_DETAILS, params, header)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    })
  }
  export const expenseStatsByDate = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.EXPENSE_STATS_BY_DATE, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err);});
    });
  }
  export const getFAQS = async () => {
    let token = await AsyncStorageFunc.getData('TOKEN');
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    const header = {
      deviceModel: "",
      appVersion: "",
      platform: "",
      network: "",
      Authorization: token ? "bearer " + token : "",
      deviceId: deviceId,
      e_platform: "web"
    };
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_FAQS, {}, header)
        .then(res => {
          resolve(res?.data || []);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
  export const getPaymentStatus = params => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.GET_PAYMENT_STATUS, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  }
  export const getVehicleTxnData = async params => {
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    let token = await AsyncStorageFunc.getData('TOKEN');
    const header = {deviceModel: "",appVersion: "",platform: "", network: "", Authorization: token ? "bearer " + token : "", vrn: params,deviceId: deviceId};
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_VEHICLE_BY_TXN_ID, {params}, header)
        .then(res => {
          resolve(res.data);
        }).catch(err => { reject(err); });
    });
  }
  export const getCorpUserDetails = params => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_CORPORATE_USER_DETAILS)
        .then(res => {
          resolve(res.data);
        }).catch(err => {reject(err);});
    });
  }